import { createFileRoute } from '@tanstack/react-router';
import { TabletApp } from '@/features/device/tablet-app.js';

/**
 * The customer-facing tablet page (tablet.md section 3). A top-level route
 * outside `_app`: the tablet is a paired device, not a signed-in employee, so
 * it never sees the sidebar or any employee session state.
 */
export const Route = createFileRoute('/device')({
  component: TabletApp,
});
